import PATHS from 'routes/paths';

export const items = {
  dispute: {
    to: PATHS.disputes,
    name: 'Dispute',
  },
  transaction: {
    to: PATHS.transactions,
    name: 'Transaction',
  },
  payout: {
    to: PATHS.payouts,
    name: 'Payout',
  },
  webhook: {
    to: PATHS.webhooks,
    name: 'Webhook',
  },
  client: {
    to: PATHS.clients,
    name: 'Client',
  },
  transfer: {
    to: PATHS.transfers,
    name: 'Transfers',
  },
};
